import { KeyboardReturnTwoTone } from "@material-ui/icons";
import React from "react";
import nextId from "react-id-generator";
import {
  Link,
  matchPath,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../DashboardContext/Context";
import "./dashboard-header.style.scss";
import MobileSidebar from "./MobileSidebar/MobileSidebar";
export default function DashboardHeader() {
  const history = useHistory();
  const [headerList, setHeaderList] = React.useState([]);
  const context = React.useContext(MainContext);
  const { userDetails, appliedJobs, updateState, savedJobs, jobListPage } =
    context;
  const [contentInside, setContentInside] = React.useState("");
  let location = useLocation();
  const matchRef = React.useRef();
  matchRef.current = matchPath(location.pathname, {
    path: "/user/list/:listType",
    exact: true,
    strict: false,
  });
  const [currentState, setCurrentState] = React.useState(
    matchRef.current?.params?.listType || ""
  );
  const handleClick = (obj) => {
    switch (obj.id) {
      case "myProfile":
        history.push("/user/profile");
        break;
      case "logout":
        updateState("logOutModal", true);

        updateState("appliedJobs", []);
        updateState("savedJobs", []);
        localStorage.clear();
        updateState("userDetails", null);
        history.push("/");

        break;
      case "saved-jobs":
        history.push("/user/list/saved-jobs");
        break;

      case "recommended-jobs":
        history.push("/user/list/recommended-jobs");
        break;
      case "applied-jobs":
        history.push("/user/list/applied-jobs");
        break;
      case "help":
        history.push("/help");
        break;

      default:
        break;
    }
  };
  const fillNumbers = () =>{
    let temp = [...listOption]
    temp[3] = { ...temp[3], count: savedJobs.length };
    temp[4] = { ...temp[4], count: appliedJobs?.length };
    setHeaderList([...temp]);

  }
  React.useEffect(() => {
    if(headerList.length === 0)return;
    fillNumbers()
  }, [savedJobs, appliedJobs]);


  React.useEffect(() => {
    if (!userDetails) {
      setHeaderList([listOption[0], listOption[1]]);
    } else {
      // setHeaderList([...listOption]);
      fillNumbers()
      
    }
  }, [userDetails]);
  return (
    <>
      <header className="dashboard-header-main">
        <nav>
          <Link to="/">
            <img src={Images.mainLogo} alt="main" />
          </Link>
          <ul>
            {headerList.map((obj) => (
              <li>
                <Link
                  onClick={(e) => {
                    if (obj?.id === "home") {
                      e.preventDefault();
                      history.push("/")
                      return;
                    }
                    updateState("jobListPage", obj?.id);
                  }}
                  className={obj?.id === jobListPage ? "current-page" : ""}
                  key={obj?.keyId}
                  to={`/user/list/${obj?.id}`}
                >
                  {obj?.name}
                  {obj?.count ? `(${obj?.count})` : ""}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="dhm-right">
          <div className="dhmr-left">
            {!userDetails ? (
              ""
            ) : (
              <div className="notification-wrapper">
                <img className="bell-icon" src={Images.bellIcon} />
                <div className="notification-list-wrapper">
                  <img className="top-point" src={Images.whiteTriangle} />
                  <header className="nlw-header">
                    <h6>Notifications</h6>
                  </header>
                  <div className="nlw-body">
                    <div className="nlw-row">
                      <div>
                        <p>No Notification found</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="dhmr-right">
            {!userDetails ? (
              <Link to="/login" className="dhmr-login">
              <img src={Images.loginLogo} />
              <span> Login/Register</span>
              </Link>
            ) : (
              <div className="dhmr-logged ">
                <img
                  className="dp"
                  height="20px"
                  onError={(e) =>
                    (e.target.src =
                      "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png")
                  }
                  src={
                    userDetails?.candidate_img ||
                    "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                  }
                />
                <p className="username">{userDetails?.candidate_full_name}</p>
                {/* <img
                  className="arrow"
                  src="https://img.icons8.com/material-sharp/50/ffffff/sort-down.png"
                /> */}

                <div className="dhmr-dropdown">
                  <div className="dhmrd-header">
                    <img
                      onError={(e) =>
                        (e.target.src =
                          "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png")
                      }
                      src={
                        userDetails?.candidate_img ||
                        "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                      }
                    />
                    <div>
                      <h6>{userDetails?.candidate_full_name}</h6>
                      <p>{userDetails?.candidate_email}</p>
                    </div>
                  </div>
                  {dropdownLists.map((obj) => (
                    <ul key={obj.keyId}>
                      {obj.list.map((x) => (
                        <li onClick={() => handleClick(x)} key={x.keyId}>
                          {x.name}
                        </li>
                      ))}
                    </ul>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <header className="dashboard-header-main-mobile">
        <nav className="dhmm-at-display">
          <img
            onClick={() =>
              userDetails ? history.push("/user") : history.push("/")
            }
            src={Images.mainLogo}
          />
          <button
            onClick={() => setContentInside("home")}
            className="dhmmad-button"
          >
            <img src="https://img.icons8.com/material-rounded/48/000000/menu--v1.png" />
          </button>
        </nav>
        {contentInside && (
          <MobileSidebar
            setContentInside={setContentInside}
            content={contentInside}
            userDetails={userDetails}
            updateState={updateState}
          />
        )}
      </header>
    </>
  );
}
const listOption = [
  { keyId: nextId(), name: "Home", id: "home" },
  { keyId: nextId(), name: "All Jobs", id: "all" },
  { keyId: nextId(), name: "Recommended Jobs", id: "recommended-jobs" },
  { keyId: nextId(), name: "Saved Jobs", id: "saved-jobs" },
  { keyId: nextId(), name: "Applied Jobs", id: "applied-jobs" },
];
const home = [];
const dropdownLists = [
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "My Profile", id: "myProfile" }],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "Recommended Jobs", id: "recommended-jobs" },
      { keyId: nextId(), name: "Saved Jobs", id: "saved-jobs" },
      { keyId: nextId(), name: "Applied Jobs", id: "applied-jobs" },
    ],
  },
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "Notifications", id: "notification" }],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "Help", id: "help" },
      { keyId: nextId(), name: "Feedback", id: "fb" },
    ],
  },
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "Log Out", id: "logout" }],
  },
];
